import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        all: [],
    },
    // -----------------------------------------------------------------
    getters: {
        all: (state) => { return state.all },
    },
    // -----------------------------------------------------------------
    mutations: {
        SET_STATISTICS(state, statistics) {
            state.all = statistics
        },
    },
    // -----------------------------------------------------------------
    actions: {
        read: (context) => {
            return Vue.api.get(`statistics`)
                .then(response => {
                    context.commit('SET_STATISTICS', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        actionStatistics: () => {
            return Vue.api.get(`action-statistics`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
    }
}